import type { QueryResult } from '@flowqa/shared';
import type { QueryClient, QueryFilters } from '@tanstack/react-query';

type EntityWithId = { id: string };

const isQueryResult = (value: unknown): value is QueryResult<EntityWithId> => {
  if (!value || typeof value !== 'object') {
    return false;
  }

  return Array.isArray((value as { items?: unknown }).items);
};

export const replaceItemInQueryResult = (current: unknown, updated: EntityWithId): unknown => {
  if (!isQueryResult(current)) {
    return current;
  }

  const updatedIndex = current.items.findIndex((item) => item.id === updated.id);
  if (updatedIndex === -1) {
    return current;
  }

  const nextItems = current.items.slice();
  nextItems[updatedIndex] = updated;

  return { ...current, items: nextItems };
};

export const patchQueryResultCaches = (
  queryClient: QueryClient,
  filters: QueryFilters[],
  updated: EntityWithId,
): void => {
  filters.forEach((filter) => {
    queryClient.setQueriesData(filter, (current) => replaceItemInQueryResult(current, updated));
  });
};
